import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import AuthService from "../services/AuthService";

export default function Login() {
  const history = useHistory();
  const isAuthenticated = AuthService.isTokenValid();

  useEffect(() => {
    if (isAuthenticated) {
      history.replace(AuthService.getLoginRedirectPath());
    }
  }, [history, isAuthenticated]);

  if (isAuthenticated) {
    return null;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const session = await AuthService.login();
      if (session) {
        history.replace(AuthService.getLoginRedirectPath());
        window.location.reload();
      }
    } catch (error) {
      console.log("error ", error);
    }
  };

  return (
    <div className="Login">
      <span style={{ textAlign: "center" }}>
        <h1>Voting Booth</h1>
      </span>
      <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 main-text-area">
        <form onSubmit={handleSubmit}>
          <p style={{ marginLeft: "22px" }}>Sign in with your Star ID account to access the Voting Booth.</p>
          <div style={{ marginLeft: "20px" }}>
            <Button block size="lg" type="submit">
              Sign In
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
